/**
 * Route for `kochava-generic-postback-template`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { KochavaGenericPostbackTemplatePage } from "../features/kochava-generic-postback-template/KochavaGenericPostbackTemplatePage";

export const kochavaGenericPostbackTemplateRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/kochava-generic-postback-template",
	component: KochavaGenericPostbackTemplatePage,
});

export default kochavaGenericPostbackTemplateRoute;
